export async function authenticatedFile(url, token) {
  const response = await fetch(url, {
    headers: { Accept: 'application/pdf', Authorization: `Bearer ${token}` },
    cache: 'no-store',
  });
  if (!response.ok) {
    const data = await response.json().catch(() => null);
    const error = new Error(data?.message || 'Não foi possível abrir o documento. Tente novamente.');
    error.status = response.status;
    throw error;
  }
  return response.blob();
}
